export default __webpack_public_path__ + "static/media/yt.66764b4a.svg";